var menu = 'closed';
jQuery('.mobile-menu-trigger').click(function(){
    (menu == 'closed') ? openMenu() : closeMenu();
});

function openMenu(){
    jQuery('header').addClass('headroom--menu-open');
    jQuery('.mobile-menu-bg').removeClass('mobile-menu-bg--hidden');
    jQuery('.mobile-menu-trigger').removeClass('mobile-menu-trigger--initial').addClass('mobile-menu-trigger--close');
    jQuery('.mobile-menu-container').addClass('mobile-menu-container--show');
    jQuery('.mobile-menu-viewport').addClass('mobile-menu-viewport--active');
    menu = 'open';
    disableScroll();
}

function closeMenu(){
    jQuery('.mobile-menu-bg').addClass('mobile-menu-bg--hidden');
    jQuery('.mobile-menu-container').removeClass('mobile-menu-container--show');
    jQuery('.mobile-menu-trigger').removeClass('mobile-menu-trigger--close').addClass('mobile-menu-trigger--initial');
    jQuery('header').removeClass('headroom--menu-open');
    jQuery('.mobile-menu-viewport').removeClass('mobile-menu-viewport--active');
    menu = 'closed';
    enableScroll();
}

function header(){
    var headroom  = new Headroom(document.querySelector("header"), {
        offset : '96',
        tolerance : {
            up : 0,
            down : 2
        }
    });
    headroom.init();
}

function mobileMenu(){
    jQuery('li.has-children > a').unbind("click");
    jQuery('li.has-children > a').click(function(){
        jQuery(this).parent().toggleClass('active');
        jQuery(this).parent().find('ul.sub-menu').slideToggle('400', 'swing');
    });
}


function disableScroll() {
    var scrolled = jQuery(window).scrollTop();
    jQuery('body').data('scrolled', scrolled);
    jQuery('body').css({'position': 'fixed',
    'top': '-' + scrolled + 'px',
    'left': '0px',
    'width': '100%',
    'overflow-y': 'scroll'});
}

function enableScroll() {
    jQuery('body').css({'position': 'relative',
    'top': 'auto',
    'left': 'auto',
    'overflow': 'auto'});
    window.scrollTo(0, jQuery('body').data('scrolled'));
}
